import { Input } from './input'

export class ConfirmationInput extends Input {
    constructor(language: string, inputData?: Partial<Input>) {
        super(language, inputData)
        this.kind = 'checkboxGroup'
        this.renderHint = 'confirmation'
        this.name = `form_fe['revision.heading_confirmationInputItem']`
        this.icon = 'fa fa-check-circle'
        this.supportScoring = true

        if (!inputData) {
            this.weight = 1
            this.addItem()
        }
    }
}
